import React from "react";
import { Button } from "@mui/material";

import "./Button.css";

const CustomButton = ({ text, icon, type, sx = {} }) => {
  return (
    <Button
      className="custom_btn"
      type={type || "button"}
      endIcon={icon ? <div className="btn_icon_container">{icon}</div> : null}
      sx={{ ...sx }}
    >
      <span className="btn_text">{text}</span>
    </Button>
  );
};

export default CustomButton;
